import React, { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import classNames from "classnames";

interface TextAreaProps {
  value: string
  onChange: (newValue: string) => void

  maxLength?: number
  onBlur?: (newValue: string) => void
  onCtrlEnter?: () => void
  onEsc?: () => void

  rows?: number
  placeholder?: string
  disabled?: boolean
  error?: boolean
  noResize?: boolean
  focusOnMount?: boolean
  fontFamily?: string
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>((props, ref) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useImperativeHandle(ref, () => textAreaRef.current);

  useEffect(() => {
    if (props.focusOnMount) {
      textAreaRef.current.focus();
      textAreaRef.current.selectionStart = textAreaRef.current.selectionEnd - textAreaRef.current.value.length;
      textAreaRef.current.scrollTop = textAreaRef.current.scrollHeight;
    }
  }, []);

  const onKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Escape") {
      props.onEsc?.();
    } else if (e.ctrlKey && e.key === "Enter") {
      props.onCtrlEnter?.();
    }
  };

  return <textarea
    ref={textAreaRef}
    className={classNames("text-area-component", {
      "text-area-component-error": props.error,
      "text-area-component-no-resize": props.noResize,
    })}
    style={{
      fontFamily: props.fontFamily ?? undefined,
    }}
    value={props.value}
    onChange={e => props.onChange(e.target.value)}
    maxLength={props.maxLength}
    rows={props.rows}
    placeholder={props.placeholder}
    disabled={props.disabled}
    onBlur={() => props.onBlur?.(props.value)}
    onKeyDown={onKeyDown}
  />;
});
